<template>
  <div>
    <DefaultLayout>
      <VFirstLoginBridgeGuidePopUp v-if="allow_insurance_bridge_guide" />
      <template slot="navigation">
        <InsuranceBridgeNavigation />
      </template>
      <vue-element-loading :active="!show" :is-full-screen="true" />
      <div v-if="show" class="mb-4">
        <OrganizationCardList :items="insurance_bridge_list" v-on:org:click="onOrgClick" />
      </div>

    </DefaultLayout>
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/Default";
import InsuranceBridgeNavigation from "@/components/insurancebridge/InsuranceBridgeNavigation";
import OrganizationCardList from "@/components/OrganizationCardList";
import VFirstLoginBridgeGuidePopUp from "@/components/VFirstLoginBridgeGuidePopUp";
import { mapState } from "vuex";

export default {
  data() {
    return {
      show: false,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        insurancebridge_insurance_selection: {
          error: {
            retrieving_insurances: "Cannot load insurances",
          },
        },
      },
    },
  },
  computed: {
    ...mapState({
      insurance_bridge_list: (state) =>
        state.organization.insurance_bridge_list,
      allow_insurance_bridge_guide: (state) =>
        state.organization.allow_insurance_bridge_guide,
    }),
  },
  methods: {
    putBreadCrumb() {
      this.$store.commit("siteconf/MUTATE_BREADCRUMB", [
        {
          langkey: "breadcrumb.home",
          to: { name: "home" },
        },
        {
          langkey: "breadcrumb.refund_insurance_selection",
          to: { name: "nopatient_insurancebridge_insurance_selection" },
        },
      ]);
    },
    onOrgClick: function (item) {
      // Route to new insurancebridge
      this.$router.push({
        name: "nopatient_insurancebridge_home",
        params: {
          pt_uuid: this.$route.params.pt_uuid,
          i_uuid: item.uuid,
          insurancebridge_uuid: "new",
        },
      });
    },
  },
  mounted: function () {
    this.putBreadCrumb();
    this.$store.dispatch("organization/INSURANCE_BRIDGE_LIST").then(
      () => {
        this.show = true;
      },
      () => {
        this.mnotify_error({
          text: this.$t(
            "insurancebridge_insurance_selection.error.retrieving_insurances"
          ),
        });
      }
    );
  },
  components: {
    DefaultLayout,
    InsuranceBridgeNavigation,
    OrganizationCardList,
    VFirstLoginBridgeGuidePopUp,
  },
};
</script>

<style>
</style>
